import { useTranslation } from 'react-i18next';
import {
  MessageOrChannelEntry,
  checkIsSameAuthor,
} from 'src/utils/messagesHelpers';
import { DateFormats, formatDate, isBefore } from 'src/utils/time';
import { Message as MessageType } from '../../types';
import { Message } from '../atoms';
import { MessageAuthorAndTime } from '../atoms/MessageAuthorAndTime';
import { Minute } from '../organisms/ReportMessages/ReportMessages.styles';
import {
  ChatContainer,
  ChatDate,
  MessageContainer,
  MessageListContainer,
} from './ChatList.styles';
import { showDate, showMinute } from './utils/helpers';

const ChatList = (props: { messages: MessageType[] }) => {
  const { t } = useTranslation();
  const orderedMessages = [...props.messages]
    .filter((m) => m) // Filter out any null messages
    .sort((a, b) => {
      if (isBefore(a.createdAt, b.createdAt)) {
        return -1;
      }

      return 1;
    });

  return (
    <MessageListContainer data-testid={'message-list-container'}>
      {orderedMessages
        .map((message, index, array) => (
          <MessageContainer key={message.id}>
            {showDate(message, array[index - 1]) && (
              <ChatDate>
                {formatDate(
                  message.createdAt,
                  DateFormats.DD_MMM_YYYY,
                  false,
                ).toUpperCase()}
              </ChatDate>
            )}
            <ChatContainer
              isSender={message.isReporter}
              sameAuthor={checkIsSameAuthor(
                index,
                array as MessageOrChannelEntry[],
              )}
            >
              <Message
                variant={message.isReporter ? 'sent' : 'received'}
                text={
                  message.deletedAt
                    ? t('public.ChatContainer.deletedMessageLabel')
                    : message.value
                }
                deleted={Boolean(message.deletedAt)}
                data-testid="report-message-box-value"
                translated={message.translated}
              />
              {(showMinute(message, array[index + 1]) || message.deletedAt) && (
                <Minute isReporter={!message.isReporter}>
                  <MessageAuthorAndTime
                    timestamp={message.deletedAt ?? message.createdAt}
                    author={message.author ?? ''}
                    translated={message.translated}
                    deleted={Boolean(message.deletedAt)}
                    deletedBy={message.deletedBy ?? ''}
                  />
                </Minute>
              )}
            </ChatContainer>
          </MessageContainer>
        ))
        .reverse()}
    </MessageListContainer>
  );
};

export default ChatList;
